import './ToolMenu.css';
import { ToolBar } from './ToolBar';
import { useToolContext } from '~/shared/contexts/ToolMenuProvider';
import { ForumTool } from './Forum';
import { Help } from './Help/Help';
import { toolItems } from './config';
import { getGenerallyIconElement } from '../parts/Button/GenerallyIcons';
import { IconButton } from '../parts/Button/IconButton';
import { TooltipAreaProvider } from '../parts/Tooltip';
import { useCallback, useRef, useState } from 'react';

export function ToolMenu() {
  const { activeToolType, setActiveToolType } = useToolContext();
  const [width, setWidth] = useState(430);
  const toolMenuRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    const startX = e.pageX;
    const startWidth = toolMenuRef.current?.offsetWidth ?? 0;

    const handleMouseMove = (e: MouseEvent) => {
      const newWidth = startWidth - (e.pageX - startX);
      if (newWidth > 200 && newWidth < 800) {
        setWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, []);

  const handleClose = () => {
    setActiveToolType('None');
  };

  const ToolItems = {
    Forum: <ForumTool />,
    Help: <Help />,
  };

  const renderIcon = (toolType: string) => {
    const activeToolIcon = toolItems.find(
      (item) => item.name === toolType
    )?.icon;
    if (!activeToolIcon) {
      return;
    }
    return (
      <>
        {getGenerallyIconElement(activeToolIcon)}
        {getGenerallyIconElement('next')}
      </>
    );
  };

  return (
    <div
      className="ToolMenu"
      ref={toolMenuRef}
      style={activeToolType !== 'None' ? { width: `${width}px` } : {}}
    >
      {activeToolType !== 'None' && (
        <div className="resize-handle" onMouseDown={handleMouseDown} />
      )}
      <TooltipAreaProvider>
        {activeToolType === 'None' ? (
          <ToolBar />
        ) : (
          <div className="tool-contents">
            <div className="tool-header" onClick={(e) => e.stopPropagation()}>
              <IconButton
                className="tool-close"
                name="close"
                buttonType="basic"
                icon={renderIcon(activeToolType)}
                onClick={handleClose}
              />
            </div>
            <div className="tool-content">{ToolItems[activeToolType]}</div>
          </div>
        )}
      </TooltipAreaProvider>
    </div>
  );
}
